module.exports = __webpack_public_path__ + "static/media/lesson-16-01.0134a89f.svg";